"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const tinycolor2_1 = __importDefault(require("tinycolor2"));
const styled_1 = __importDefault(require("../../utils/styled"));
const constants_1 = require("../../utils/constants");
const Icon_1 = require("../../Icon");
const Container = styled_1.default("div")(({ theme, color_ }) => {
    const backgroundColor = tinycolor2_1.default(constants_1.expandColor(theme, color_) || theme.color.primary)
        .setAlpha(0.9)
        .toString();
    return {
        backgroundColor,
        color: theme.color.white,
        overflow: "hidden",
        boxShadow: "0 2px 6px rgba(0, 0, 0, .15)",
        padding: "8px 52px 8px 16px",
        borderRadius: theme.borderRadius,
        minHeight: 36,
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        position: "relative",
        maxWidth: 400,
    };
});
const IconContainer = styled_1.default("div")(({ theme }) => ({
    position: "absolute",
    top: 0,
    right: 0,
    cursor: "pointer",
    width: 36,
    height: 36,
    borderBottomLeftRadius: theme.borderRadius,
    borderTopRightRadius: theme.borderRadius,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    ":hover": {
        backgroundColor: "rgba(0, 0, 0, 0.1)",
    },
}));
exports.Message = (_a) => {
    var { color, onClose, children } = _a, props = __rest(_a, ["color", "onClose", "children"]);
    return (React.createElement(Container, Object.assign({}, props, { color_: color }),
        React.createElement(IconContainer, { onClick: e => {
                e.stopPropagation();
                if (onClose) {
                    onClose();
                }
            } },
            React.createElement(Icon_1.NoIcon, null)),
        children));
};
exports.default = exports.Message;
//# sourceMappingURL=Message.js.map